import fetch from "./sessionFetch";
import { baseUrl } from './apiUtils';

async function getWeek(weekStart) {
  const url = `${baseUrl}public/timetable?weekStart=${encodeURIComponent(weekStart)}`;
  for (let attempt = 0; attempt < 2; attempt += 1) {
    let response;
    try {
      // eslint-disable-next-line no-await-in-loop
      response = await fetch(url, { credentials: 'omit', cache: 'no-store' });
    } catch (error) {
      if (error.name === 'AbortError' || attempt === 1) throw new Error('Public timetable unavailable');
    }
    if (response && response.ok) return response.json();
    if (attempt === 1 || (response && ![502, 503, 504].includes(response.status))) throw new Error('Public timetable unavailable');
    // Retry this anonymous read once; never retry domain writes here.
    // eslint-disable-next-line no-await-in-loop
    await new Promise(resolve => setTimeout(resolve, 250));
  }
  throw new Error('Public timetable unavailable');
}

export default { getWeek };
